// signInSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { InitialSignInProps } from '../../../interfaces/ISignIn';

const initialState: InitialSignInProps = {
  email: '',
};

const signInSlice = createSlice({
  name: 'signInSlice',
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    clearEmail: (state) => {
      state.email = '';
    },
  },
});

export const { setEmail, clearEmail } = signInSlice.actions;
export default signInSlice.reducer;
